import { useState, useEffect } from "react";
import { Component } from "@/components/dashboard/PieChart";
import { Metrics } from "@/components/dashboard/Metrics";
import Spinner from "@/components/Spinner";
import getMetrics from "@/scripts/getMetrics";

function Dashboard() {
  const [data, setData] = useState();

  const getData = async () => {
    try {
      const metrics = await getMetrics();
      setData(metrics);
    } catch (error) {
      console.log("Error fetching data", error);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  if (!data) {
    return <Spinner />;
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full p-6">
      <Metrics type="User" data={data} />
      <Component data={data} />
      <Metrics type="Buy" data={data} />
      <Metrics type="Sell" data={data} />
      <Metrics type="Agent" data={data} />
    </div>
  );
}

export default Dashboard;
